import WhatWeOffer from './what-we-offer';

export default WhatWeOffer;
